import React, { useState, useEffect } from "react";
import Avatar from "@material-ui/core/Avatar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import AddIcon from "@material-ui/icons/Add";
import { blue } from "@material-ui/core/colors";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import DoneIcon from "@material-ui/icons/Done";
import DescriptionIcon from "@material-ui/icons/Description";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import { Box, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import pleasewait from "../../img/waiting.svg.svg";
// import { CircularProgressbar } from "react-circular-progressbar";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";

import "react-circular-progressbar/dist/styles.css";
import "./styles/modal.css";
const percentage = 66;

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#1a90ff",
  },
}))(LinearProgress);

function LinearProgressWithLabel(props) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <BorderLinearProgress variant="determinate" {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">{`${Math.round(
          props.value
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

const SelectModal = (props) => {
  const useStyles = makeStyles({
    avatar: {
      backgroundColor: blue[100],
      color: blue[600],
    },
    checkedBox: {
      backgroundColor: "azure",
    },
    cssOutlinedInput: {
      "&$cssFocused $notchedOutline": {
        borderColor: `green !important`,
      },
    },
  });

  // const [onClose, setonClose] = useState(true);
  const [imagecover, setimagecover] = useState(pleasewait);
  const [selectedValue, setselectedValue] = useState("");
  const [selection, setselection] = useState(0);
  const [open, setopen] = useState(false);
  const [filter, setFilter] = useState("");
  const [selectall, setselectall] = useState(false);
  const [checkboxes, setcheckboxes] = useState({
    couverture: false,
    sommaire: false,
    contexte_intercalaire: false,
    contexte: false,
    chiffres_cles: false,
    description: false,
    caracteristiques: false,
    photos: false,
    bien_similaire_vente: false,
    bien_similaire_Location: false,
    autour_du_bien: false,
    finance: false,
    budget: false,
    revenu: false,
    charges: false,
    financement: false,
    fiscalite: false,
    modele_financier: false,
    marche: false,
    marche_local: false,
    prix_vente_commune: false,
    prix_location_commune: false,
    localisation: false,
    population_ville: false,
    logement_ville: false,
    transport: false,
    commerces: false,
    sante: false,
    fin: false,
  });
  const [NextPage, setNextPage] = useState(0);
  const [progress, setprogress] = useState(0);
  const [progresslabels, setprogresslabels] = useState("");

  const listPage = [
    "couverture",
    "sommaire",
    "contexte_intercalaire",
    "contexte",
    "chiffres_cles",
    "description",
    "caracteristiques",
    "photos",
    "bien_similaire_vente",
    "bien_similaire_Location",
    "autour_du_bien",
    "finance",
    "budget",
    "revenu",
    "charges",
    "financement",
    "fiscalite",
    "modele_financier",
    "marche",
    "marche_local",
    "prix_vente_commune",
    "prix_location_commune",
    "localisation",
    "population_ville",
    "logement_ville",
    "transport",
    "commerces",
    "sante",
    "fin",
  ];

  const classes = useStyles();

  const handledisplay = (section) => {
    var nomchecked = "";
    switch (section) {
      case "chiffres_cles":
        nomchecked = "Chiffres clés";
        break;
      case "contexte":
        nomchecked = "Contexte du projet";
        break;
      case "caracteristiques":
        nomchecked = "Caractéristiques";
        break;
      case "photos":
        nomchecked = "Photos du bien";
        break;
      case "autour_du_bien":
        nomchecked = "Autour du bien";
        break;
      case "bien_similaire_vente":
        nomchecked = "Biens similaires à la vente";
        break;
      case "bien_similaire_Location":
        nomchecked = "Biens similaires à la location";
        break;
      case "budget":
        nomchecked = "Budget détaillé";
        break;
      case "revenu":
        nomchecked = "Revenus";
        break;
      case "charges":
        nomchecked = "Charges d'exploitation";
        break;
      case "financement":
        nomchecked = "Financement";
        break;
      case "fiscalite":
        nomchecked = "Fiscalité";
        break;
      case "modele_financier":
        nomchecked = "Modèle financier";
        break;
      case "marche_local":
        nomchecked = "Le marché local";
        break;
      case "prix_vente_commune":
        nomchecked = "Prix de vente";
        break;
      case "prix_location_commune":
        nomchecked = "Prix de location";
        break;

      case "population_ville":
        nomchecked = "Population";
        break;

      case "logement_ville":
        nomchecked = "Logement";
        break;
      case "transport":
        nomchecked = "Transports/enseignements";
        break;
      case "commerces":
        nomchecked = "Commerces/loisirs";
        break;
      case "sante":
        nomchecked = "Santé/administration";
        break;

      default:
        nomchecked = section.charAt(0).toUpperCase() + section.slice(1);
        break;
    }

    return nomchecked;
  };

  function Icon() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="animated"
        version="1.1"
        viewBox="0 0 500 500"
        width="100%"
        height="100%"
      >
        <g
          className="animable"
          style={{
            WebkitTransformOrigin: 260.278,
            MsTransformOrigin: 260.278,
            transformOrigin: 260.278,
          }}
        >
          <path
            d="M456.39 312.8s20.13-106.45-34.7-166.8c-48.4-53.31-125-74-187.48-30-22.21 15.7-38.46 46.2-64.46 55.62-29.15 10.57-66.62 14.38-93.69 59.64S58.71 334.69 94.8 365.65s99.25.75 156.16-1.51 175.59 80.02 205.43-51.34z"
            style={{
              WebkitTransformOrigin: 260.278,
              MsTransformOrigin: 260.278,
              transformOrigin: 260.278,
            }}
            fill="#122659"
            className="animable"
          ></path>
          <path
            d="M456.39 312.8s20.13-106.45-34.7-166.8c-48.4-53.31-125-74-187.48-30-22.21 15.7-38.46 46.2-64.46 55.62-29.15 10.57-66.62 14.38-93.69 59.64S58.71 334.69 94.8 365.65s99.25.75 156.16-1.51 175.59 80.02 205.43-51.34z"
            style={{
              WebkitTransformOrigin: 260.278,
              MsTransformOrigin: 260.278,
              transformOrigin: 260.278,
            }}
            fill="#FFF"
            className="animable"
            opacity="0.8"
          ></path>
        </g>
        <g
          className="animable"
          style={{
            WebkitTransformOrigin: 333.17,
            MsTransformOrigin: 333.17,
            transformOrigin: 333.17,
          }}
        >
          <path
            d="M260.4 152h63.5v18.06h-63.5a5.13 5.13 0 01-5.13-5.13v-7.81a5.13 5.13 0 015.13-5.12z"
            style={{
              WebkitTransformOrigin: 289.585,
              MsTransformOrigin: 289.585,
              transformOrigin: 289.585,
            }}
            fill="#122659"
            className="animable"
          ></path>
          <path
            d="M323.9 129.47h-59.6a9 9 0 00-9 9 9 9 0 009 9h59.6z"
            style={{
              WebkitTransformOrigin: 289.6,
              MsTransformOrigin: 289.6,
              transformOrigin: 289.6,
            }}
            fill="#122659"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 340.155,
              MsTransformOrigin: 340.155,
              transformOrigin: 340.155,
            }}
            fill="#122659"
            d="M329.32 108.7H350.99V169.2H329.32z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 367.245,
              MsTransformOrigin: 367.245,
              transformOrigin: 367.245,
            }}
            fill="#122659"
            d="M356.41 108.7H378.08000000000004V169.2H356.41z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 394.335,
              MsTransformOrigin: 394.335,
              transformOrigin: 394.335,
            }}
            fill="#122659"
            d="M383.5 108.7H405.17V169.2H383.5z"
            className="animable"
          ></path>
          <path
            d="M260.4 152h63.5v18.06h-63.5a5.13 5.13 0 01-5.13-5.13v-7.81a5.13 5.13 0 015.13-5.12z"
            style={{
              WebkitTransformOrigin: 289.585,
              MsTransformOrigin: 289.585,
              transformOrigin: 289.585,
            }}
            fill="#FFF"
            className="animable"
            opacity="0.4"
          ></path>
          <path
            d="M323.9 129.47h-59.6a9 9 0 00-9 9 9 9 0 009 9h59.6z"
            style={{
              WebkitTransformOrigin: 289.6,
              MsTransformOrigin: 289.6,
              transformOrigin: 289.6,
            }}
            fill="#FFF"
            className="animable"
            opacity="0.4"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 340.155,
              MsTransformOrigin: 340.155,
              transformOrigin: 340.155,
            }}
            fill="#FFF"
            d="M329.32 108.7H350.99V169.2H329.32z"
            className="animable"
            opacity="0.4"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 367.245,
              MsTransformOrigin: 367.245,
              transformOrigin: 367.245,
            }}
            fill="#FFF"
            d="M356.41 108.7H378.08000000000004V169.2H356.41z"
            className="animable"
            opacity="0.4"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 394.335,
              MsTransformOrigin: 394.335,
              transformOrigin: 394.335,
            }}
            fill="#FFF"
            d="M383.5 108.7H405.17V169.2H383.5z"
            className="animable"
            opacity="0.4"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 333.17,
              MsTransformOrigin: 333.17,
              transformOrigin: 333.17,
            }}
            fill="#122659"
            d="M418.26 170.82L248.08 170.82 248.08 180.9 261.89 180.9 261.89 205.9 270.11 205.9 270.11 180.9 392.22 180.9 392.22 205.9 400.44 205.9 400.44 180.9 418.26 180.9 418.26 170.82z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 333.17,
              MsTransformOrigin: 333.17,
              transformOrigin: 333.17,
            }}
            d="M418.26 170.82L248.08 170.82 248.08 180.9 261.89 180.9 261.89 205.9 270.11 205.9 270.11 180.9 392.22 180.9 392.22 205.9 400.44 205.9 400.44 180.9 418.26 180.9 418.26 170.82z"
            className="animable"
            opacity="0.1"
          ></path>
        </g>
        <g
          className="animable"
          style={{
            WebkitTransformOrigin: 165.575,
            MsTransformOrigin: 165.575,
            transformOrigin: 165.575,
          }}
        >
          <path
            d="M215 200.82a54.13 54.13 0 00-5.69 2.21c1-.75 2-1.51 3-2.3a143.59 143.59 0 0012.87-11.65 138.79 138.79 0 01-15.24 12.8 33.82 33.82 0 001.95-4c1-2.52 1.19-5-1.22-6.41-3-1.66-6.55.83-5.6 5.1a15.52 15.52 0 003.26 6.43 96.69 96.69 0 01-10.93 6.56l-.36.18a35.14 35.14 0 002.11-4.3c1-2.52 1.2-5.05-1.21-6.41-3-1.67-6.56.82-5.6 5.1a15.5 15.5 0 003.2 6.36c-4.55 2.24-9.25 4.14-13.93 6.21l-.68.31a30.74 30.74 0 002.54-3.12c1.52-2.23 2.34-4.64.31-6.52-2.49-2.31-6.57-.72-6.64 3.66a15.8 15.8 0 001.65 7 71 71 0 00-12.4 7.36l-.12.09a23.77 23.77 0 001.43-2.57c1.15-2.44 1.57-5-.73-6.48a3.76 3.76 0 00-5.66 1.75 3.35 3.35 0 00-1.21-1.15c-2.32-1.34-4.6.11-6.55 2.16-.51.53-1 1.1-1.45 1.68a71.78 71.78 0 015.67-12.07 17.11 17.11 0 006.81 1.46c4.62 0 6.57-3.85 4.3-6.24-1.84-1.94-4.44-1.2-6.89.21-.81.47-1.6 1-2.34 1.54a69.38 69.38 0 018-9.9 17.37 17.37 0 006.58 3.31c4.49 1.11 7.31-2.15 5.68-5-1.32-2.33-4-2.24-6.74-1.46a33.27 33.27 0 00-3.76 1.39c1.22-1.19 2.49-2.34 3.77-3.47 1.69-1.44 3.43-2.83 5.2-4.18a17.38 17.38 0 006.48 3.23c4.48 1.11 7.3-2.15 5.68-5-1.32-2.33-4-2.23-6.74-1.45-.63.18-1.27.4-1.89.63 2.34-1.67 4.72-3.3 7.1-4.93l2.2-1.5a17.51 17.51 0 006.82 3.5c4.49 1.11 7.3-2.15 5.68-5-1.32-2.34-4-2.24-6.74-1.46a29 29 0 00-3.13 1.12c.46-.32.91-.65 1.36-1 .84-.6 1.66-1.21 2.48-1.84 1-.76 2-1.61 3-2.41.56-.45 1.1-.93 1.64-1.42a17.1 17.1 0 006.85 3.54c4.49 1.11 7.31-2.14 5.69-5-1.32-2.33-4-2.24-6.75-1.46a37.59 37.59 0 00-4.41 1.67c1.83-1.7 3.6-3.47 5.28-5.32.12-.13.22-.26.33-.39.73-.8 1.44-1.61 2.13-2.44s1.57-2 2.33-3a57.57 57.57 0 007.53-13.17 56.57 56.57 0 01-7.79 13 82 82 0 01-10.4 11l-.41.35a38.76 38.76 0 002.3-4.65c1-2.52 1.2-5.05-1.21-6.41-3-1.66-6.56.82-5.6 5.1a15.83 15.83 0 003.55 6.78l-.89.76c-.35.29-.71.59-1.07.87-.59.48-1.19.94-1.79 1.39l-1 .74c-.86.63-1.74 1.26-2.62 1.87L193 175l-1.44 1a36.5 36.5 0 002.21-4.47c1-2.52 1.2-5.05-1.21-6.41-3-1.67-6.56.82-5.61 5.1a15.75 15.75 0 003.4 6.59l-1.07.69-4 2.58-.77.51c-.74.48-1.47 1-2.2 1.47-.32.21-.64.42-.95.64-1 .7-2.05 1.41-3.06 2.14a38.41 38.41 0 002.25-4.54c1-2.52 1.2-5.06-1.21-6.41-3-1.67-6.56.82-5.61 5.09a15.74 15.74 0 003.47 6.68c-1.72 1.26-3.42 2.56-5.08 3.91-1.2 1-2.39 2.06-3.55 3.12a27.27 27.27 0 001.35-2.89c1-2.52 1.2-5-1.21-6.41-3-1.66-6.56.82-5.61 5.1a15.74 15.74 0 003.21 6.37 71.21 71.21 0 00-8.83 10.67 26.28 26.28 0 00.67-3.36c.33-2.68-.06-5.2-2.72-5.93-3.28-.9-6.17 2.38-4.21 6.3a15.7 15.7 0 004.7 5.44 74 74 0 00-6.36 13.14 25.19 25.19 0 00-.29-2.86c-.45-2.66-1.53-5-4.29-4.91-3.4.06-5.24 4-2.25 7.23a15.49 15.49 0 005.7 3.76 94.89 94.89 0 00-2.82 10.81c-.11.58-.21 1.16-.31 1.74a2.9 2.9 0 00-.36.34c-.12-.5-.26-1-.42-1.49-.86-2.56-2.28-4.67-5-4.19-3.35.59-4.55 4.79-1.11 7.49a15.26 15.26 0 005.93 2.77 1.78 1.78 0 00.12.29c-.37 2.75-.65 5.51-.82 8.29q-.19 3.1-.25 6.23c-2.9 0-5 3.17-2.94 6.62a14.56 14.56 0 003.18 3.77c.25 3.9.63 7.8 1.15 11.67a3.2 3.2 0 00-3.1-.71c-1.83.49-2.65 2-2.94 3.77a3.65 3.65 0 00-1 2.49c-1.36-2-2.64-4.09-3.88-6.19a17.21 17.21 0 004.62-5.4c2.18-4.07-.27-7.61-3.45-6.74-2.59.7-3.16 3.34-3.08 6.17a30.42 30.42 0 00.3 3.2l-1.25-2.43c-1.12-2-2.07-4-3.12-6.08-.27-.49-.5-1-.72-1.51a17.24 17.24 0 005.55-4.43c2.9-3.59 1.15-7.53-2.13-7.27-2.68.2-3.73 2.69-4.18 5.48a31.61 31.61 0 00-.33 3.68l-1-2.2a112.44 112.44 0 01-5-15.33 17.43 17.43 0 006.42-4c3.25-3.29 1.91-7.38-1.39-7.46-2.68-.06-4 2.31-4.71 5a36.9 36.9 0 00-.8 4.46c-.71-3-1.32-6-1.82-9.07-.35-1.89-.57-3.8-.81-5.71a17.21 17.21 0 007.16-3.21c3.65-2.83 2.84-7.06-.42-7.57-2.64-.41-4.24 1.77-5.32 4.39a42.75 42.75 0 00-1.58 5.09c-.21-2.22-.44-4.43-.54-6.65a101.91 101.91 0 01.06-13.76 102.22 102.22 0 00-.48 13.78c0 2.12.18 4.23.31 6.35a33 33 0 00-2-4.19c-1.38-2.32-3.23-4.07-5.78-3-3.15 1.29-3.42 5.66.52 7.56a15.78 15.78 0 007.42 1.41c.18 1.89.34 3.78.62 5.65.4 3 .91 6 1.5 8.91a29.42 29.42 0 00-2.15-3.25c-1.68-2.12-3.73-3.62-6.13-2.25-3 1.69-2.66 6.05 1.5 7.42a15.65 15.65 0 007.29.49 114.32 114.32 0 004.55 15.55l.6 1.52c-.54-.69-1.12-1.4-1.73-2-1.88-1.94-4.07-3.22-6.32-1.62-2.77 2-2 6.29 2.23 7.24a15.66 15.66 0 007.15-.21c.21.52.42 1 .67 1.55 1 2.08 1.92 4.22 3 6.27.3.59.61 1.17.92 1.75-.53-.45-1.08-.89-1.65-1.29-2.2-1.56-4.6-2.41-6.51-.41-2.34 2.46-.82 6.56 3.56 6.69a15.55 15.55 0 006.55-1.35c1.25 2.27 2.55 4.51 3.94 6.71.52.84 1.06 1.67 1.6 2.5a26.54 26.54 0 00-2.51-2.07c-2.21-1.56-4.61-2.41-6.51-.41-2.35 2.46-.83 6.56 3.55 6.69a15.73 15.73 0 007.22-1.66c.72 1 1.47 2 2.25 3-1.63 1.89-1.1 5.1 2.21 6.52a14.89 14.89 0 005.11 1.12c.2.17.41.33.62.48l.11.08c.77 2.88 1.61 5.74 2.49 8.58H137.2v47.11h37.16v-47.14h-17.31c-1.49-5.09-2.74-9.52-3-9.64l-.52-.25a17 17 0 005.35-3c3.52-3 2.52-7.19-.75-7.54-2.67-.3-4.17 1.95-5.12 4.62a23 23 0 00-.7 2.32c-.19-.71-.38-1.42-.56-2.13-.54-2.1-1-4.22-1.5-6.33a17.18 17.18 0 005.79-3.19c3.52-3 2.52-7.18-.75-7.54-2.67-.29-4.16 2-5.12 4.62a24.59 24.59 0 00-.71 2.36c-.31-1.54-.6-3.08-.87-4.63-.2-1.16-.38-2.31-.55-3.46-.07-1.64-.09-3.29-.07-4.93 0-.91 0-1.81.08-2.72a16.85 16.85 0 006.15.79c4.62-.3 6.32-4.25 3.91-6.5-2-1.82-4.51-.92-6.87.64a33.07 33.07 0 00-3 2.34 73.62 73.62 0 011.76-11.48 62.09 62.09 0 011.94-6.54 17.24 17.24 0 006.6.92c4.61-.29 6.32-4.25 3.91-6.49-2-1.83-4.51-.92-6.87.64a29.5 29.5 0 00-2.42 1.83 48.16 48.16 0 013.1-6.07 44.33 44.33 0 018.74-10.47 17.33 17.33 0 006.13 3.63c4.4 1.44 7.45-1.6 6-4.58-1.14-2.42-3.84-2.53-6.62-2a31.65 31.65 0 00-3.11.86h.07a69.71 69.71 0 0112.13-7.62 17.37 17.37 0 005.66 4.79c4.11 2.12 7.61-.38 6.7-3.55-.74-2.58-3.39-3.11-6.22-3a29.91 29.91 0 00-3.31.37c4.57-2.16 9.23-4.2 13.73-6.58l.1-.05a17.39 17.39 0 007 3.65c4.49 1.11 7.31-2.15 5.68-5-1.31-2.34-4-2.24-6.74-1.46-.76.21-1.51.49-2.25.77a102.68 102.68 0 008.72-5.69l.24.25a.37.37 0 010-.11 17.49 17.49 0 007 3.7c4.49 1.1 7.31-2.15 5.69-5-1.22-2.32-3.92-2.32-6.6-1.5zm-70.85 91.81c-.91-1.07-1.79-2.19-2.64-3.32.21-.19.43-.4.65-.62a15.65 15.65 0 003.9.7v.21l.62-.12c.32 1.59.66 3.19 1 4.78a4.19 4.19 0 00-3.57-1.63zm3.31-38.14c-.31 1.19-.58 2.39-.83 3.59l-.15-.21q0-3.7.11-7.39c.07-1.73.2-3.45.35-5.16a16.51 16.51 0 002.73 2.27 66.71 66.71 0 00-2.25 6.9zm4.16-11.35c0-.45.1-.91.13-1.35v-.68c.36-.11.73-.24 1.1-.39-.46.8-.85 1.6-1.27 2.42zm5.27-8.57a3.25 3.25 0 00-1.85-1.74c-2.5-1-4.53.82-6.14 3.14l-.08.12-.16-.05-.52-.07c0-.14.05-.28.07-.42a91.53 91.53 0 012.59-10.82 17.37 17.37 0 006.94-.54 5.93 5.93 0 003.4-2.35 15.94 15.94 0 002.5 5.68 47.91 47.91 0 00-6.79 7.05z"
            style={{
              WebkitTransformOrigin: 165.575,
              MsTransformOrigin: 165.575,
              transformOrigin: 165.575,
            }}
            fill="#122659"
            className="animable"
          ></path>
        </g>
        <g
          className="animable"
          style={{
            WebkitTransformOrigin: 324.6,
            MsTransformOrigin: 324.6,
            transformOrigin: 324.6,
          }}
        >
          <path
            d="M235.66 217.26h177.77a8 8 0 018 8V350h0-193.74 0V225.23a8 8 0 017.97-7.97z"
            style={{
              WebkitTransformOrigin: 324.56,
              MsTransformOrigin: 324.56,
              transformOrigin: 324.56,
            }}
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 324.545,
              MsTransformOrigin: 324.545,
              transformOrigin: 324.545,
            }}
            fill="#FFF"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M450.46 408.67L198.63 408.67 227.69 349.99 421.4 349.99 450.46 408.67z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 324.545,
              MsTransformOrigin: 324.545,
              transformOrigin: 324.545,
            }}
            fill="#122659"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M239.42 227.77H409.66999999999996V339.48H239.42z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 311.34,
              MsTransformOrigin: 311.34,
              transformOrigin: 311.34,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M316.46 368.56L316.8 361.41 306.56 361.41 305.88 368.56 316.46 368.56z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 332.325,
              MsTransformOrigin: 332.325,
              transformOrigin: 332.325,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M337.62 368.56L337.27 361.41 327.03 361.41 327.04 368.56 337.62 368.56z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 397.08,
              MsTransformOrigin: 397.08,
              transformOrigin: 397.08,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M392.71 376.21L403.65 376.21 401.08 368.56 390.51 368.56 392.71 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 300.935,
              MsTransformOrigin: 300.935,
              transformOrigin: 300.935,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M305.88 368.56L306.56 361.41 296.33 361.41 295.31 368.56 305.88 368.56z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 280.12,
              MsTransformOrigin: 280.12,
              transformOrigin: 280.12,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M284.73 368.56L286.09 361.41 275.86 361.41 274.15 368.56 284.73 368.56z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 373.955,
              MsTransformOrigin: 373.955,
              transformOrigin: 373.955,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M379.93 368.56L378.21 361.41 367.98 361.41 369.35 368.56 379.93 368.56z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 384.36,
              MsTransformOrigin: 384.36,
              transformOrigin: 384.36,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M390.51 368.56L388.45 361.41 378.21 361.41 379.93 368.56 390.51 368.56z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 269.715,
              MsTransformOrigin: 269.715,
              transformOrigin: 269.715,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M274.15 368.56L275.86 361.41 265.62 361.41 263.57 368.56 274.15 368.56z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 342.73,
              MsTransformOrigin: 342.73,
              transformOrigin: 342.73,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M348.19 368.56L347.5 361.41 337.27 361.41 337.62 368.56 348.19 368.56z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 394.765,
              MsTransformOrigin: 394.765,
              transformOrigin: 394.765,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M401.08 368.56L398.68 361.41 388.45 361.41 390.51 368.56 401.08 368.56z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 363.545,
              MsTransformOrigin: 363.545,
              transformOrigin: 363.545,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M369.35 368.56L367.98 361.41 357.74 361.41 358.77 368.56 369.35 368.56z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 353.135,
              MsTransformOrigin: 353.135,
              transformOrigin: 353.135,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M358.77 368.56L357.74 361.41 347.5 361.41 348.19 368.56 358.77 368.56z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 321.75,
              MsTransformOrigin: 321.75,
              transformOrigin: 321.75,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M327.04 368.56L327.03 361.41 316.8 361.41 316.46 368.56 327.04 368.56z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 246.25,
              MsTransformOrigin: 246.25,
              transformOrigin: 246.25,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M253 368.56L242.42 368.56 239.5 376.21 250.44 376.21 253 368.56z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 248.9,
              MsTransformOrigin: 248.9,
              transformOrigin: 248.9,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M255.38 361.41L245.15 361.41 242.42 368.56 253 368.56 255.38 361.41z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 259.31,
              MsTransformOrigin: 259.31,
              transformOrigin: 259.31,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M263.57 368.56L265.62 361.41 255.38 361.41 253 368.56 263.57 368.56z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 240.35,
              MsTransformOrigin: 240.35,
              transformOrigin: 240.35,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M236.37 384.4L233 393.2 244.76 393.2 247.7 384.4 236.37 384.4z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 243.405,
              MsTransformOrigin: 243.405,
              transformOrigin: 243.405,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M250.44 376.21L239.5 376.21 236.37 384.4 247.7 384.4 250.44 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 251.9,
              MsTransformOrigin: 251.9,
              transformOrigin: 251.9,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M247.7 384.4L244.76 393.2 256.52 393.2 259.04 384.4 247.7 384.4z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 290.53,
              MsTransformOrigin: 290.53,
              transformOrigin: 290.53,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M295.31 368.56L296.33 361.41 286.09 361.41 284.73 368.56 295.31 368.56z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 289.29,
              MsTransformOrigin: 289.29,
              transformOrigin: 289.29,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M294.21 376.21L295.31 368.56 284.73 368.56 283.27 376.21 294.21 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 278.53,
              MsTransformOrigin: 278.53,
              transformOrigin: 278.53,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M283.27 376.21L284.73 368.56 274.15 368.56 272.33 376.21 283.27 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 300.045,
              MsTransformOrigin: 300.045,
              transformOrigin: 300.045,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M305.16 376.21L305.88 368.56 295.31 368.56 294.21 376.21 305.16 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 257.005,
              MsTransformOrigin: 257.005,
              transformOrigin: 257.005,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M263.57 368.56L253 368.56 250.44 376.21 261.38 376.21 263.57 368.56z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 399.56,
              MsTransformOrigin: 399.56,
              transformOrigin: 399.56,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M395.07 384.4L406.41 384.4 403.65 376.21 392.71 376.21 395.07 384.4z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 267.765,
              MsTransformOrigin: 267.765,
              transformOrigin: 267.765,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M272.33 376.21L274.15 368.56 263.57 368.56 261.38 376.21 272.33 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 254.54,
              MsTransformOrigin: 254.54,
              transformOrigin: 254.54,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M250.44 376.21L247.7 384.4 259.04 384.4 261.38 376.21 250.44 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 364.795,
              MsTransformOrigin: 364.795,
              transformOrigin: 364.795,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M370.82 376.21L369.35 368.56 358.77 368.56 359.88 376.21 370.82 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 354.035,
              MsTransformOrigin: 354.035,
              transformOrigin: 354.035,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M359.88 376.21L358.77 368.56 348.19 368.56 348.93 376.21 359.88 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 386.32,
              MsTransformOrigin: 386.32,
              transformOrigin: 386.32,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M392.71 376.21L390.51 368.56 379.93 368.56 381.76 376.21 392.71 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 321.575,
              MsTransformOrigin: 321.575,
              transformOrigin: 321.575,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M327.05 376.21L327.04 368.56 316.46 368.56 316.1 376.21 327.05 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 343.275,
              MsTransformOrigin: 343.275,
              transformOrigin: 343.275,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M348.93 376.21L348.19 368.56 337.62 368.56 337.99 376.21 348.93 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 332.515,
              MsTransformOrigin: 332.515,
              transformOrigin: 332.515,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M337.99 376.21L337.62 368.56 327.04 368.56 327.05 376.21 337.99 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 310.81,
              MsTransformOrigin: 310.81,
              transformOrigin: 310.81,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M316.1 376.21L316.46 368.56 305.88 368.56 305.16 376.21 316.1 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 354.995,
              MsTransformOrigin: 354.995,
              transformOrigin: 354.995,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M348.93 376.21L349.73 384.4 361.06 384.4 359.88 376.21 348.93 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 366.14,
              MsTransformOrigin: 366.14,
              transformOrigin: 366.14,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M359.88 376.21L361.06 384.4 372.4 384.4 370.82 376.21 359.88 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 265.685,
              MsTransformOrigin: 265.685,
              transformOrigin: 265.685,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M261.38 376.21L259.04 384.4 270.38 384.4 272.33 376.21 261.38 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 377.275,
              MsTransformOrigin: 377.275,
              transformOrigin: 377.275,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M370.82 376.21L372.4 384.4 383.73 384.4 381.76 376.21 370.82 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 332.72,
              MsTransformOrigin: 332.72,
              transformOrigin: 332.72,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M327.05 376.21L327.05 384.4 338.39 384.4 337.99 376.21 327.05 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 388.415,
              MsTransformOrigin: 388.415,
              transformOrigin: 388.415,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M381.76 376.21L383.73 384.4 395.07 384.4 392.71 376.21 381.76 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 343.86,
              MsTransformOrigin: 343.86,
              transformOrigin: 343.86,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M337.99 376.21L338.39 384.4 349.73 384.4 348.93 376.21 337.99 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 287.96,
              MsTransformOrigin: 287.96,
              transformOrigin: 287.96,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M283.27 376.21L281.71 384.4 293.05 384.4 294.21 376.21 283.27 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 276.825,
              MsTransformOrigin: 276.825,
              transformOrigin: 276.825,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M272.33 376.21L270.38 384.4 281.71 384.4 283.27 376.21 272.33 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 321.385,
              MsTransformOrigin: 321.385,
              transformOrigin: 321.385,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M316.1 376.21L315.72 384.4 327.05 384.4 327.05 376.21 316.1 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 310.24,
              MsTransformOrigin: 310.24,
              transformOrigin: 310.24,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M305.16 376.21L304.38 384.4 315.72 384.4 316.1 376.21 305.16 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 299.105,
              MsTransformOrigin: 299.105,
              transformOrigin: 299.105,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M294.21 376.21L293.05 384.4 304.38 384.4 305.16 376.21 294.21 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 375.555,
              MsTransformOrigin: 375.555,
              transformOrigin: 375.555,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M381.76 376.21L379.93 368.56 369.35 368.56 370.82 376.21 381.76 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 251.49,
              MsTransformOrigin: 251.49,
              transformOrigin: 251.49,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M255.38 361.41L257.83 354.09 247.94 354.09 245.15 361.41 255.38 361.41z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 238.9,
              MsTransformOrigin: 238.9,
              transformOrigin: 238.9,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M245.15 361.41L235.7 361.41 232.65 368.56 242.42 368.56 245.15 361.41z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 241.82,
              MsTransformOrigin: 241.82,
              transformOrigin: 241.82,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M247.94 354.09L238.82 354.09 235.7 361.41 245.15 361.41 247.94 354.09z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 235.91,
              MsTransformOrigin: 235.91,
              transformOrigin: 235.91,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M242.42 368.56L232.65 368.56 229.4 376.21 239.5 376.21 242.42 368.56z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 232.7,
              MsTransformOrigin: 232.7,
              transformOrigin: 232.7,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M239.5 376.21L229.4 376.21 225.9 384.4 236.37 384.4 239.5 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 229.26,
              MsTransformOrigin: 229.26,
              transformOrigin: 229.26,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M236.37 384.4L225.9 384.4 222.15 393.2 233 393.2 236.37 384.4z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 417.97,
              MsTransformOrigin: 417.97,
              transformOrigin: 417.97,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M411.66 368.56L414.6 376.21 424.28 376.21 421.02 368.56 411.66 368.56z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 421.185,
              MsTransformOrigin: 421.185,
              transformOrigin: 421.185,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M417.74 384.4L427.77 384.4 424.28 376.21 414.6 376.21 417.74 384.4z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 424.63,
              MsTransformOrigin: 424.63,
              transformOrigin: 424.63,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M421.12 393.2L431.52 393.2 427.77 384.4 417.74 384.4 421.12 393.2z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 332.15,
              MsTransformOrigin: 332.15,
              transformOrigin: 332.15,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M337.27 361.41L336.91 354.09 327.03 354.09 327.03 361.41 337.27 361.41z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 414.97,
              MsTransformOrigin: 414.97,
              transformOrigin: 414.97,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M411.66 368.56L421.02 368.56 417.97 361.41 408.92 361.41 411.66 368.56z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 410.695,
              MsTransformOrigin: 410.695,
              transformOrigin: 410.695,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M406.41 384.4L417.74 384.4 414.6 376.21 403.65 376.21 406.41 384.4z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 261.545,
              MsTransformOrigin: 261.545,
              transformOrigin: 261.545,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M265.62 361.41L267.71 354.09 257.83 354.09 255.38 361.41 265.62 361.41z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 405.17,
              MsTransformOrigin: 405.17,
              transformOrigin: 405.17,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M398.68 361.41L401.08 368.56 411.66 368.56 408.92 361.41 398.68 361.41z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 412.04,
              MsTransformOrigin: 412.04,
              transformOrigin: 412.04,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M417.97 361.41L414.85 354.09 406.11 354.09 408.92 361.41 417.97 361.41z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 402.57,
              MsTransformOrigin: 402.57,
              transformOrigin: 402.57,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M408.92 361.41L406.11 354.09 396.22 354.09 398.68 361.41 408.92 361.41z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 379.125,
              MsTransformOrigin: 379.125,
              transformOrigin: 379.125,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M372.4 384.4L374.09 393.2 385.85 393.2 383.73 384.4 372.4 384.4z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 413.765,
              MsTransformOrigin: 413.765,
              transformOrigin: 413.765,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M409.36 393.2L421.12 393.2 417.74 384.4 406.41 384.4 409.36 393.2z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 392.51,
              MsTransformOrigin: 392.51,
              transformOrigin: 392.51,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M398.68 361.41L396.22 354.09 386.34 354.09 388.45 361.41 398.68 361.41z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 402.215,
              MsTransformOrigin: 402.215,
              transformOrigin: 402.215,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M395.07 384.4L397.61 393.2 409.36 393.2 406.41 384.4 395.07 384.4z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 390.67,
              MsTransformOrigin: 390.67,
              transformOrigin: 390.67,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M383.73 384.4L385.85 393.2 397.61 393.2 395.07 384.4 383.73 384.4z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 407.84,
              MsTransformOrigin: 407.84,
              transformOrigin: 407.84,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M403.65 376.21L414.6 376.21 411.66 368.56 401.08 368.56 403.65 376.21z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 301.795,
              MsTransformOrigin: 301.795,
              transformOrigin: 301.795,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M306.56 361.41L307.26 354.09 297.37 354.09 296.33 361.41 306.56 361.41z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 382.45,
              MsTransformOrigin: 382.45,
              transformOrigin: 382.45,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M388.45 361.41L386.34 354.09 376.45 354.09 378.21 361.41 388.45 361.41z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 291.73,
              MsTransformOrigin: 291.73,
              transformOrigin: 291.73,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M296.33 361.41L297.37 354.09 287.49 354.09 286.09 361.41 296.33 361.41z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 321.915,
              MsTransformOrigin: 321.915,
              transformOrigin: 321.915,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M327.03 361.41L327.03 354.09 317.14 354.09 316.8 361.41 327.03 361.41z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 281.675,
              MsTransformOrigin: 281.675,
              transformOrigin: 281.675,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M286.09 361.41L287.49 354.09 277.6 354.09 275.86 361.41 286.09 361.41z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 271.61,
              MsTransformOrigin: 271.61,
              transformOrigin: 271.61,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M275.86 361.41L277.6 354.09 267.71 354.09 265.62 361.41 275.86 361.41z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 311.85,
              MsTransformOrigin: 311.85,
              transformOrigin: 311.85,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M316.8 361.41L317.14 354.09 307.26 354.09 306.56 361.41 316.8 361.41z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 372.39,
              MsTransformOrigin: 372.39,
              transformOrigin: 372.39,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M378.21 361.41L376.45 354.09 366.57 354.09 367.98 361.41 378.21 361.41z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 362.33,
              MsTransformOrigin: 362.33,
              transformOrigin: 362.33,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M367.98 361.41L366.57 354.09 356.68 354.09 357.74 361.41 367.98 361.41z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 342.205,
              MsTransformOrigin: 342.205,
              transformOrigin: 342.205,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M347.5 361.41L346.8 354.09 336.91 354.09 337.27 361.41 347.5 361.41z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 315.305,
              MsTransformOrigin: 315.305,
              transformOrigin: 315.305,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M372.4 384.4L361.06 384.4 349.73 384.4 338.39 384.4 327.05 384.4 315.72 384.4 304.38 384.4 293.05 384.4 281.71 384.4 270.38 384.4 259.04 384.4 256.52 393.2 268.28 393.2 280.03 393.2 291.79 393.2 303.55 393.2 315.31 393.2 327.06 393.2 338.82 393.2 350.58 393.2 362.33 393.2 374.09 393.2 372.4 384.4z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 352.27,
              MsTransformOrigin: 352.27,
              transformOrigin: 352.27,
            }}
            fill="#263238"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M357.74 361.41L356.68 354.09 346.8 354.09 347.5 361.41 357.74 361.41z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 324.6,
              MsTransformOrigin: 324.6,
              transformOrigin: 324.6,
            }}
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M198.63 408.66H450.57V412.23H198.63z"
            className="animable"
          ></path>
        </g>
        <g
          className="animable"
          style={{
            WebkitTransformOrigin: 224.5,
            MsTransformOrigin: 224.5,
            transformOrigin: 224.5,
          }}
        >
          <path
            style={{
              WebkitTransformOrigin: 277.715,
              MsTransformOrigin: 277.715,
              transformOrigin: 277.715,
            }}
            d="M391.91 253.25L391.91 349.34 363.98 385.75 359.28 387.51 216 408.65 216 413.35 163.52 416.17 163.52 364.61 253 364.61 253 252.79 391.91 253.25z"
            className="animable"
            opacity="0.15"
          ></path>
          <path
            d="M131.34 354.3c-6.45.32-13.44 5.24-13.44 5.24L45 416.17h118.52s74.83-56.47 77.07-58.09c3.55-2.56 10.59-3.86 10.59-3.86l-3.33.08z"
            style={{
              WebkitTransformOrigin: 148.09,
              MsTransformOrigin: 148.09,
              transformOrigin: 148.09,
            }}
            fill="#FFF"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 324.695,
              MsTransformOrigin: 324.695,
              transformOrigin: 324.695,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M404 253.34L245.39 253.34"
            className="animable"
          ></path>
          <path
            d="M380.08 219.16A11.82 11.82 0 00368.25 231v145.41a12 12 0 01-16 11.29l-89.73-31.87a26 26 0 00-14.66-.82V231a11.83 11.83 0 0111.83-11.83z"
            style={{
              WebkitTransformOrigin: 313.97,
              MsTransformOrigin: 313.97,
              transformOrigin: 313.97,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <g
            style={{
              WebkitTransformOrigin: 320.89,
              MsTransformOrigin: 320.89,
              transformOrigin: 320.89,
            }}
            className="animable"
            clipPath='url("#freepik--clip-path--inject-5")'
          >
            <path
              d="M273.54 359.75l78.7 27.95a12 12 0 0016-11.29v-16.66z"
              style={{
                WebkitTransformOrigin: 320.89,
                MsTransformOrigin: 320.89,
                transformOrigin: 320.89,
              }}
              fill="#122659"
              className="animable"
            ></path>
            <path
              d="M273.54 359.75l78.7 27.95a12 12 0 0016-11.29v-16.66z"
              style={{
                WebkitTransformOrigin: 320.89,
                MsTransformOrigin: 320.89,
                transformOrigin: 320.89,
              }}
              fill="#FFF"
              className="animable"
              opacity="0.6"
            ></path>
            <path
              d="M273.54 378.9l78.7 28a12 12 0 0016-11.3v-16.7z"
              style={{
                WebkitTransformOrigin: 320.89,
                MsTransformOrigin: 320.89,
                transformOrigin: 320.89,
              }}
              fill="#122659"
              className="animable"
            ></path>
          </g>
          <path
            d="M380.08 219.16A11.82 11.82 0 00368.25 231v145.41a12 12 0 01-16 11.29l-89.73-31.87a26 26 0 00-14.66-.82V231a11.83 11.83 0 0111.83-11.83z"
            style={{
              WebkitTransformOrigin: 313.97,
              MsTransformOrigin: 313.97,
              transformOrigin: 313.97,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 250.4,
              MsTransformOrigin: 250.4,
              transformOrigin: 250.4,
            }}
            fill="#FFF"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M252.95 354.3L247.85 354.3"
            className="animable"
          ></path>
          <path
            d="M356.27 388.41h-120.4a11.92 11.92 0 01-4-.71l-20.79-7.31 25.85-19.9a26.17 26.17 0 0125.6-4.66l89.73 31.87a11.94 11.94 0 004.01.71z"
            style={{
              WebkitTransformOrigin: 283.675,
              MsTransformOrigin: 283.675,
              transformOrigin: 283.675,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <g
            style={{
              WebkitTransformOrigin: 283.03,
              MsTransformOrigin: 283.03,
              transformOrigin: 283.03,
            }}
            className="animable"
            clipPath='url("#freepik--clip-path-2--inject-5")'
          >
            <path
              d="M356.27 388.41h-120.4a11.92 11.92 0 01-4-.71l-22.08-7.7 27.12-19.51a26.17 26.17 0 0125.6-4.66l89.73 31.87a11.94 11.94 0 004.03.71z"
              style={{
                WebkitTransformOrigin: 283.03,
                MsTransformOrigin: 283.03,
                transformOrigin: 283.03,
              }}
              fill="#122659"
              className="animable"
            ></path>
            <path
              d="M356.27 388.41h-120.4a11.92 11.92 0 01-4-.71l-22.08-7.7 27.12-19.51a26.17 26.17 0 0125.6-4.66l89.73 31.87a11.94 11.94 0 004.03.71z"
              style={{
                WebkitTransformOrigin: 283.03,
                MsTransformOrigin: 283.03,
                transformOrigin: 283.03,
              }}
              className="animable"
              opacity="0.2"
            ></path>
          </g>
          <path
            d="M356.27 388.41h-120.4a11.92 11.92 0 01-4-.71l-20.79-7.31 25.85-19.9a26.17 26.17 0 0125.6-4.66l89.73 31.87a11.94 11.94 0 004.01.71z"
            style={{
              WebkitTransformOrigin: 283.675,
              MsTransformOrigin: 283.675,
              transformOrigin: 283.675,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 235.74,
              MsTransformOrigin: 235.74,
              transformOrigin: 235.74,
            }}
            fill="#FFF"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M235.87 388.41L235.61 388.41"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 356.385,
              MsTransformOrigin: 356.385,
              transformOrigin: 356.385,
            }}
            fill="#FFF"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M356.5 388.41L356.27 388.41"
            className="animable"
          ></path>
          <path
            d="M388.44 222.63a11.74 11.74 0 00-8.36-3.47c-12.32 0-11.83 11.83-11.83 11.83v22.26h23.66V231a11.76 11.76 0 00-3.47-8.37z"
            style={{
              WebkitTransformOrigin: 380.079,
              MsTransformOrigin: 380.079,
              transformOrigin: 380.079,
            }}
            fill="#FFF"
            className="animable"
          ></path>
          <g
            style={{
              WebkitTransformOrigin: 380.079,
              MsTransformOrigin: 380.079,
              transformOrigin: 380.079,
            }}
            className="animable"
            clipPath='url("#freepik--clip-path-3--inject-5")'
          >
            <path
              d="M388.44 222.63a11.74 11.74 0 00-8.36-3.47c-12.32 0-11.83 11.83-11.83 11.83v22.26h23.66V231a11.76 11.76 0 00-3.47-8.37z"
              style={{
                WebkitTransformOrigin: 380.079,
                MsTransformOrigin: 380.079,
                transformOrigin: 380.079,
              }}
              fill="#122659"
              className="animable"
            ></path>
            <path
              d="M388.44 222.63a11.74 11.74 0 00-8.36-3.47c-12.32 0-11.83 11.83-11.83 11.83v22.26h23.66V231a11.76 11.76 0 00-3.47-8.37z"
              style={{
                WebkitTransformOrigin: 380.079,
                MsTransformOrigin: 380.079,
                transformOrigin: 380.079,
              }}
              className="animable"
              opacity="0.2"
            ></path>
          </g>
          <path
            d="M388.44 222.63a11.74 11.74 0 00-8.36-3.47c-12.32 0-11.83 11.83-11.83 11.83v22.26h23.66V231a11.76 11.76 0 00-3.47-8.37z"
            style={{
              WebkitTransformOrigin: 380.079,
              MsTransformOrigin: 380.079,
              transformOrigin: 380.079,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="animable"
          ></path>
          <g
            style={{
              WebkitTransformOrigin: 309.555,
              MsTransformOrigin: 309.555,
              transformOrigin: 309.555,
            }}
            className="animable"
            opacity="0.15"
          >
            <path
              className="animable"
              style={{
                WebkitTransformOrigin: 264.615,
                MsTransformOrigin: 264.615,
                transformOrigin: 264.615,
              }}
              d="M258.9 239.54L258.9 239.75 258.9 244.8 258.9 245.01 258.9 250.06 258.9 250.27 258.9 255.31 258.9 255.52 258.9 260.57 258.9 260.78 258.9 265.83 258.9 266.04 258.9 271.08 258.9 271.29 258.9 276.34 258.9 276.55 258.9 281.6 258.9 281.81 258.9 286.85 258.9 287.06 258.9 292.11 258.9 292.32 258.9 297.58 270.33 297.58 270.33 292.32 270.33 292.11 270.33 287.06 270.33 286.85 270.33 281.81 270.33 281.6 270.33 276.55 270.33 276.34 270.33 271.29 270.33 271.08 270.33 266.04 270.33 265.83 270.33 260.78 270.33 260.57 270.33 255.52 270.33 255.31 270.33 250.27 270.33 250.06 270.33 245.01 270.33 244.8 270.33 239.75 270.33 239.54 270.33 234.29 258.9 234.29 258.9 239.54z"
            ></path>
            <path
              className="animable"
              style={{
                WebkitTransformOrigin: 315.345,
                MsTransformOrigin: 315.345,
                transformOrigin: 315.345,
              }}
              d="M349.02 234.29L348.78 234.29 337.84 234.29 337.59 234.29 326.65 234.29 326.4 234.29 315.47 234.29 315.22 234.29 304.28 234.29 304.03 234.29 293.1 234.29 292.85 234.29 281.91 234.29 281.66 234.29 270.48 234.29 270.48 239.75 281.66 239.75 281.91 239.75 292.85 239.75 293.1 239.75 304.03 239.75 304.28 239.75 315.22 239.75 315.47 239.75 326.4 239.75 326.65 239.75 337.59 239.75 337.84 239.75 348.78 239.75 349.02 239.75 360.21 239.75 360.21 234.29 349.02 234.29z"
            ></path>
          </g>
          <path
            style={{
              WebkitTransformOrigin: 264.615,
              MsTransformOrigin: 264.615,
              transformOrigin: 264.615,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M258.9 234.29H270.33V239.76H258.9z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 264.615,
              MsTransformOrigin: 264.615,
              transformOrigin: 264.615,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M258.9 239.54H270.33V245.01H258.9z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 264.615,
              MsTransformOrigin: 264.615,
              transformOrigin: 264.615,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M258.9 244.8H270.33V250.27H258.9z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 264.615,
              MsTransformOrigin: 264.615,
              transformOrigin: 264.615,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M258.9 250.06H270.33V255.53H258.9z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 264.615,
              MsTransformOrigin: 264.615,
              transformOrigin: 264.615,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M258.9 255.31H270.33V260.78000000000003H258.9z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 264.615,
              MsTransformOrigin: 264.615,
              transformOrigin: 264.615,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M258.9 260.57H270.33V266.04H258.9z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 264.615,
              MsTransformOrigin: 264.615,
              transformOrigin: 264.615,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M258.9 265.83H270.33V271.3H258.9z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 264.615,
              MsTransformOrigin: 264.615,
              transformOrigin: 264.615,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M258.9 271.08H270.33V276.55H258.9z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 264.615,
              MsTransformOrigin: 264.615,
              transformOrigin: 264.615,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M258.9 276.34H270.33V281.81H258.9z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 264.615,
              MsTransformOrigin: 264.615,
              transformOrigin: 264.615,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M258.9 281.6H270.33V287.07000000000005H258.9z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 264.615,
              MsTransformOrigin: 264.615,
              transformOrigin: 264.615,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M258.9 286.85H270.33V292.32000000000005H258.9z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 264.615,
              MsTransformOrigin: 264.615,
              transformOrigin: 264.615,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M258.9 292.11H270.33V297.58000000000004H258.9z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 276.195,
              MsTransformOrigin: 276.195,
              transformOrigin: 276.195,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M270.48 234.29H281.91V239.76H270.48z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 287.375,
              MsTransformOrigin: 287.375,
              transformOrigin: 287.375,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M281.66 234.29H293.09000000000003V239.76H281.66z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 298.565,
              MsTransformOrigin: 298.565,
              transformOrigin: 298.565,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M292.85 234.29H304.28000000000003V239.76H292.85z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 309.745,
              MsTransformOrigin: 309.745,
              transformOrigin: 309.745,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M304.03 234.29H315.46V239.76H304.03z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 320.935,
              MsTransformOrigin: 320.935,
              transformOrigin: 320.935,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M315.22 234.29H326.65000000000003V239.76H315.22z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 332.115,
              MsTransformOrigin: 332.115,
              transformOrigin: 332.115,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M326.4 234.29H337.83V239.76H326.4z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 343.305,
              MsTransformOrigin: 343.305,
              transformOrigin: 343.305,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M337.59 234.29H349.02V239.76H337.59z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 354.495,
              MsTransformOrigin: 354.495,
              transformOrigin: 354.495,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M348.78 234.29H360.21V239.76H348.78z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 315.265,
              MsTransformOrigin: 315.265,
              transformOrigin: 315.265,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M270.33 239.75H360.2V297.57H270.33z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 281.76,
              MsTransformOrigin: 281.76,
              transformOrigin: 281.76,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M281.76 239.75L281.76 297.56"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 292.95,
              MsTransformOrigin: 292.95,
              transformOrigin: 292.95,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M292.95 239.75L292.95 297.56"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 304.14,
              MsTransformOrigin: 304.14,
              transformOrigin: 304.14,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M304.14 239.75L304.14 297.56"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 315.33,
              MsTransformOrigin: 315.33,
              transformOrigin: 315.33,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M315.33 239.75L315.33 297.56"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 326.51,
              MsTransformOrigin: 326.51,
              transformOrigin: 326.51,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M326.51 239.75L326.51 297.56"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 337.7,
              MsTransformOrigin: 337.7,
              transformOrigin: 337.7,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M337.7 239.75L337.7 297.56"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 348.89,
              MsTransformOrigin: 348.89,
              transformOrigin: 348.89,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M348.89 239.75L348.89 297.56"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 315.235,
              MsTransformOrigin: 315.235,
              transformOrigin: 315.235,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M270.33 245.01L360.14 245.01"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 315.235,
              MsTransformOrigin: 315.235,
              transformOrigin: 315.235,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M270.33 250.25L360.14 250.25"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 315.235,
              MsTransformOrigin: 315.235,
              transformOrigin: 315.235,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M270.33 255.49L360.14 255.49"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 315.235,
              MsTransformOrigin: 315.235,
              transformOrigin: 315.235,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M270.33 260.73L360.14 260.73"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 315.235,
              MsTransformOrigin: 315.235,
              transformOrigin: 315.235,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M270.33 265.97L360.14 265.97"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 315.235,
              MsTransformOrigin: 315.235,
              transformOrigin: 315.235,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M270.33 271.2L360.14 271.2"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 315.235,
              MsTransformOrigin: 315.235,
              transformOrigin: 315.235,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M270.33 276.44L360.14 276.44"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 315.235,
              MsTransformOrigin: 315.235,
              transformOrigin: 315.235,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M270.33 281.68L360.14 281.68"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 315.235,
              MsTransformOrigin: 315.235,
              transformOrigin: 315.235,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M270.33 286.92L360.14 286.92"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 315.235,
              MsTransformOrigin: 315.235,
              transformOrigin: 315.235,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M270.33 292.16L360.14 292.16"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 168.19,
              MsTransformOrigin: 168.19,
              transformOrigin: 168.19,
            }}
            fill="#122659"
            d="M213.04 368.38L116.69 368.38 123.34 363.33 219.69 363.33 213.04 368.38z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 94.525,
              MsTransformOrigin: 94.525,
              transformOrigin: 94.525,
            }}
            fill="#122659"
            d="M65.7 408.92L63.34 408.92 123.34 363.33 125.71 363.33 65.7 408.92z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 147.405,
              MsTransformOrigin: 147.405,
              transformOrigin: 147.405,
            }}
            fill="#263238"
            d="M191.81 384.48L95.47 384.48 103 378.84 199.34 378.84 191.81 384.48z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 141.36,
              MsTransformOrigin: 141.36,
              transformOrigin: 141.36,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M159.38 409.15L63.03 409.15 123.34 363.33 219.69 363.33 159.38 409.15z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 103.245,
              MsTransformOrigin: 103.245,
              transformOrigin: 103.245,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M133.27 363.5L73.22 409.12"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 112.925,
              MsTransformOrigin: 112.925,
              transformOrigin: 112.925,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M142.95 363.5L82.9 409.12"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 122.595,
              MsTransformOrigin: 122.595,
              transformOrigin: 122.595,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M152.62 363.5L92.57 409.12"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 132.275,
              MsTransformOrigin: 132.275,
              transformOrigin: 132.275,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M162.3 363.5L102.25 409.12"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 141.955,
              MsTransformOrigin: 141.955,
              transformOrigin: 141.955,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M171.98 363.5L111.93 409.12"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 151.63,
              MsTransformOrigin: 151.63,
              transformOrigin: 151.63,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M181.66 363.5L121.6 409.12"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 161.305,
              MsTransformOrigin: 161.305,
              transformOrigin: 161.305,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M191.33 363.5L131.28 409.12"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 170.985,
              MsTransformOrigin: 170.985,
              transformOrigin: 170.985,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M201.01 363.5L140.96 409.12"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 180.66,
              MsTransformOrigin: 180.66,
              transformOrigin: 180.66,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M210.69 363.5L150.63 409.12"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 158.82,
              MsTransformOrigin: 158.82,
              transformOrigin: 158.82,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M110.79 372.99L206.85 372.99"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 151.15,
              MsTransformOrigin: 151.15,
              transformOrigin: 151.15,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M103.12 378.82L199.18 378.82"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 143.48,
              MsTransformOrigin: 143.48,
              transformOrigin: 143.48,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M95.45 384.65L191.51 384.65"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 135.81,
              MsTransformOrigin: 135.81,
              transformOrigin: 135.81,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M87.78 390.47L183.84 390.47"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 128.14,
              MsTransformOrigin: 128.14,
              transformOrigin: 128.14,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M80.11 396.3L176.17 396.3"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 120.47,
              MsTransformOrigin: 120.47,
              transformOrigin: 120.47,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M72.44 402.13L168.5 402.13"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 309.585,
              MsTransformOrigin: 309.585,
              transformOrigin: 309.585,
            }}
            fill="#122659"
            d="M258.81 301.99H360.36V305.72H258.81z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 260.055,
              MsTransformOrigin: 260.055,
              transformOrigin: 260.055,
            }}
            fill="#122659"
            d="M258.81 301.99H261.3V350.03000000000003H258.81z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 309.585,
              MsTransformOrigin: 309.585,
              transformOrigin: 309.585,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M258.81 301.99H360.36V350.28000000000003H258.81z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 269.51,
              MsTransformOrigin: 269.51,
              transformOrigin: 269.51,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M269.51 302.17L269.51 350.25"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 279.71,
              MsTransformOrigin: 279.71,
              transformOrigin: 279.71,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M279.71 302.17L279.71 350.25"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 289.91,
              MsTransformOrigin: 289.91,
              transformOrigin: 289.91,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M289.91 302.17L289.91 350.25"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 300.11,
              MsTransformOrigin: 300.11,
              transformOrigin: 300.11,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M300.11 302.17L300.11 350.25"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 310.31,
              MsTransformOrigin: 310.31,
              transformOrigin: 310.31,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M310.31 302.17L310.31 350.25"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 320.51,
              MsTransformOrigin: 320.51,
              transformOrigin: 320.51,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M320.51 302.17L320.51 350.25"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 330.71,
              MsTransformOrigin: 330.71,
              transformOrigin: 330.71,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M330.71 302.17L330.71 350.25"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 340.9,
              MsTransformOrigin: 340.9,
              transformOrigin: 340.9,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M340.9 302.17L340.9 350.25"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 351.1,
              MsTransformOrigin: 351.1,
              transformOrigin: 351.1,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M351.1 302.17L351.1 350.25"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 309.605,
              MsTransformOrigin: 309.605,
              transformOrigin: 309.605,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M258.98 312.17L360.23 312.17"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 309.605,
              MsTransformOrigin: 309.605,
              transformOrigin: 309.605,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M258.98 318.32L360.23 318.32"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 309.605,
              MsTransformOrigin: 309.605,
              transformOrigin: 309.605,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M258.98 324.46L360.23 324.46"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 309.605,
              MsTransformOrigin: 309.605,
              transformOrigin: 309.605,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M258.98 330.6L360.23 330.6"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 309.605,
              MsTransformOrigin: 309.605,
              transformOrigin: 309.605,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M258.98 336.74L360.23 336.74"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 309.605,
              MsTransformOrigin: 309.605,
              transformOrigin: 309.605,
            }}
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.25"
            d="M258.98 342.88L360.23 342.88"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 324.625,
              MsTransformOrigin: 324.625,
              transformOrigin: 324.625,
            }}
            fill="#263238"
            stroke="#263238"
            strokeMiterlimit="10"
            strokeWidth="0.5"
            d="M322.51 332.81H326.74V342.69H322.51z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 331.405,
              MsTransformOrigin: 331.405,
              transformOrigin: 331.405,
            }}
            fill="#122659"
            stroke="#263238"
            strokeMiterlimit="10"
            strokeWidth="0.5"
            d="M329.29 326.89H333.52000000000004V342.7H329.29z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 338.175,
              MsTransformOrigin: 338.175,
              transformOrigin: 338.175,
            }}
            fill="#263238"
            stroke="#263238"
            strokeMiterlimit="10"
            strokeWidth="0.5"
            d="M336.06 317.01H340.29V342.7H336.06z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 344.955,
              MsTransformOrigin: 344.955,
              transformOrigin: 344.955,
            }}
            fill="#122659"
            stroke="#263238"
            strokeMiterlimit="10"
            strokeWidth="0.5"
            d="M342.84 326.6H347.07V342.69H342.84z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 351.725,
              MsTransformOrigin: 351.725,
              transformOrigin: 351.725,
            }}
            fill="#263238"
            stroke="#263238"
            strokeMiterlimit="10"
            strokeWidth="0.5"
            d="M349.61 317.01H353.84000000000003V342.7H349.61z"
            className="animable"
          ></path>
          <path
            d="M283.19 330.82v11.74a11.74 11.74 0 010-23.48h0z"
            style={{
              WebkitTransformOrigin: 277.32,
              MsTransformOrigin: 277.32,
              transformOrigin: 277.32,
            }}
            fill="#122659"
            stroke="#263238"
            strokeMiterlimit="10"
            strokeWidth="0.5"
            className="animable"
          ></path>
          <path
            d="M283.19 330.82l11.16-3.63a11.73 11.73 0 01-7.53 14.81 11.21 11.21 0 01-3.63.58z"
            style={{
              WebkitTransformOrigin: 289.061,
              MsTransformOrigin: 289.061,
              transformOrigin: 289.061,
            }}
            fill="#FFF"
            stroke="#263238"
            strokeMiterlimit="10"
            strokeWidth="0.5"
            className="animable"
          ></path>
          <path
            d="M283.19 330.82v-11.74a11.55 11.55 0 0111.16 8.11z"
            style={{
              WebkitTransformOrigin: 288.77,
              MsTransformOrigin: 288.77,
              transformOrigin: 288.77,
            }}
            fill="#263238"
            stroke="#263238"
            strokeMiterlimit="10"
            strokeWidth="0.5"
            className="animable"
          ></path>
        </g>
        <defs>
          <filter height="200%">
            <feMorphology
              in="SourceAlpha"
              operator="dilate"
              radius="2"
              result="DILATED"
            ></feMorphology>
            <feFlood
              floodColor="#32DFEC"
              floodOpacity="1"
              result="PINK"
            ></feFlood>
            <feComposite
              in="PINK"
              in2="DILATED"
              operator="in"
              result="OUTLINE"
            ></feComposite>
            <feMerge>
              <feMergeNode in="OUTLINE"></feMergeNode>
              <feMergeNode in="SourceGraphic"></feMergeNode>
            </feMerge>
          </filter>
          <filter height="200%">
            <feMorphology
              in="SourceAlpha"
              operator="dilate"
              radius="2"
              result="DILATED"
            ></feMorphology>
            <feFlood
              floodColor="red"
              floodOpacity="0.5"
              result="PINK"
            ></feFlood>
            <feComposite
              in="PINK"
              in2="DILATED"
              operator="in"
              result="OUTLINE"
            ></feComposite>
            <feMerge>
              <feMergeNode in="OUTLINE"></feMergeNode>
              <feMergeNode in="SourceGraphic"></feMergeNode>
            </feMerge>
            <feColorMatrix values="0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"></feColorMatrix>
          </filter>
        </defs>
        <defs>
          <clipPath id="freepik--clip-path--inject-5">
            <path
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M380.08 219.16A11.82 11.82 0 00368.25 231v145.41a12 12 0 01-16 11.29l-89.73-31.87a26 26 0 00-14.66-.82V231a11.83 11.83 0 0111.83-11.83z"
            ></path>
          </clipPath>
          <clipPath id="freepik--clip-path-2--inject-5">
            <path
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M356.27 388.41h-120.4a11.92 11.92 0 01-4-.71l-20.79-7.31 25.85-19.9a26.17 26.17 0 0125.6-4.66l89.73 31.87a11.94 11.94 0 004.01.71z"
            ></path>
          </clipPath>
          <clipPath id="freepik--clip-path-3--inject-5">
            <path
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M388.44 222.63a11.74 11.74 0 00-8.36-3.47c-12.32 0-11.83 11.83-11.83 11.83v22.26h23.66V231a11.76 11.76 0 00-3.47-8.37z"
            ></path>
          </clipPath>
        </defs>
      </svg>
    );
  }

  const handleClose = () => {
    props.onClose(selectedValue);
    resetall();
  };

  const hundle_generation = () => {
    props.handle_generate(checkboxes);
  };
  useEffect(() => {}, [checkboxes, progresslabels]);

  useEffect(() => {
    if (NextPage === 1) {
      props.generate();
    }
  }, [NextPage]);
  useEffect(() => {
    setprogress(props.progress);
  }, [props.progress]);

  useEffect(() => {
    setprogresslabels(props.progresslabels);
  }, [props.progresslabels]);

  useEffect(() => {
    setimagecover(props.imgcurr);
  }, [props.imgcurr]);

  useEffect(() => {}, [checkboxes]);

  const resetall = () => {
    console.log("reset executed");
    listPage.map((page) => {
      checkboxes[page] = false;
    });
    setcheckboxes({ ...checkboxes });
    setselectall(false);
    setselection(0);
    // setNextPage(false);
  };

  const selectallmethod = () => {
    if (selectall === false) {
      listPage.map((page) => {
        checkboxes[page] = true;
      });
      setcheckboxes({ ...checkboxes });
      setselection(listPage.length);

      setselectall(true);
    } else {
      listPage.map((page) => {
        checkboxes[page] = false;
      });
      setcheckboxes({ ...checkboxes });
      setselectall(false);
      setselection(0);
    }
  };

  const handleListItemClick = (value) => {
    console.log(value);
    if (!checkboxes[value] == true) {
      setselection(selection + 1);
    } else {
      setselection(selection - 1);
    }
    checkboxes[value] = !checkboxes[value];
    setcheckboxes({ ...checkboxes });
    console.log(checkboxes);
  };

  useEffect(() => {
    setopen(props.open);
  }, [props.open]);
  return (
    <Dialog
      disableBackdropClick
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      keepMounted
      open={props.open}
      maxWidth={"md"}
      fullWidth={true}
      style={{
        overflowX: "hidden",
        overflowY: "hidden",
      }}
    >
      <DialogTitle id="simple-dialog-title">Télecharger votre pdf</DialogTitle>
      <>
        {NextPage === 0 && (
          <Grid
            container
            spacing={3}
            style={{
              height: "400px",
              width: "100%",
              overflowX: "hidden",
            }}
          >
            <Grid item xs={6}>
              <Icon />
            </Grid>
            {/* {props.imgarray &&
              props.imgarray.map((img) => {
                return (
                  <Grid item xs={4}>
                    <img
                      style={{ width: "100%", height: "100%" }}
                      src={img.img}
                    ></img>
                  </Grid>
                );
              })} */}
            <Grid item xs={5} style={{ display: "flex", alignItems: "center" }}>
              <p style={{ textAlign: "left", fontSize: "1.4rem" }}>
                cliquez sur générer pour lancer le processus de téléchargement
              </p>
            </Grid>
          </Grid>
        )}
        {NextPage === 1 && (
          <Grid
            container
            spacing={3}
            style={{
              height: "400px",
              width: "100%",

              overflowX: "hidden",
            }}
          >
            <Grid
              item
              xs={5}
              style={{
                overflowX: "hidden",
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "center",
                padding: "5%",
              }}
            >
              <CircularProgressbar
                value={props.progress}
                text={`${Math.trunc(props.progress)}%`}
                styles={buildStyles({
                  // Rotation of path and trail, in number of turns (0-1)
                  rotation: 0.25,

                  // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                  strokeLinecap: "butt",

                  // Text size
                  textSize: "16px",

                  // How long animation takes to go from one percentage to another, in seconds
                  pathTransitionDuration: 0.5,

                  // Can specify path transition in more detail, or remove it entirely
                  // pathTransition: 'none',

                  // Colors
                  pathColor: `rgba(46,214,255, ${percentage / 100})`,
                  textColor: "rgba(46,214,255)",
                  trailColor: "#d6d6d6",
                  backgroundColor: "#3e98c7",
                })}
              />
              <p style={{ fontSize: "1.5rem", marginTop: "1rem" }}>
                {props.progresslabels}
              </p>
            </Grid>
            <Grid item xs={7} style={{ padding: "5%" }}>
              <img
                src={imagecover}
                style={{ width: "100%", height: "100%" }}
                alt=""
              />
            </Grid>
          </Grid>
        )}
      </>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "20px",
        }}
      >
        {NextPage === 0 && (
          <Button
            style={{ color: "#1877F2", margin: "10px" }}
            onClick={handleClose}
          >
            Annuler
          </Button>
        )}

        <>
          {NextPage === 1 ? (
            <Button
              disabled={
                props.progresslabels?.includes("terminée") ? false : true
              }
              style={{
                backgroundColor: props.progresslabels?.includes("terminée")
                  ? "#122659"
                  : "e3e3e3",
                margin: "10px",
                color: props.progresslabels?.includes("terminée")
                  ? "#fff"
                  : "e3e3e3",
              }}
              onClick={() => props.handle_generate()}
            >
              Télecharger
            </Button>
          ) : (
            <Button
              style={{ color: "#1877F2", margin: "10px" }}
              onClick={() => setNextPage(1)}
            >
              Génerer
            </Button>
          )}
        </>
      </div>
      {/* <ListItem
          autoFocus
          button
          onClick={() => handleListItemClick("addAccount")}
        >
          <ListItemAvatar>
            <Avatar>
              <AddIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary="Add account" />
        </ListItem>
      </List> */}
    </Dialog>
  );
};

export default SelectModal;
